<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['DM']['ALTDM']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAlternateDomain">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <CRow>
                                                <CCol col="12" class="form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["DM"]["AGI"]}}<span class="required" /> :</label>
                                                    <customtreeselect :multiple="false"
                                                                      :options="dd_agentgroup3"
                                                                      :flat="true"
                                                                      :defaultExpandLevel="Infinity"
                                                                      :clearable="false"
                                                                      :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                                      v-model="obj_ADomain.AGIT"
                                                                      @input="DomainAgentGroupChange"
                                                                      :disabled="obj_ADomain.I > 0"
                                                                      ref="AGI" />
                                                    <span class="ErrMsg">{{ ValidationNewAlternateDomainErrMsg('AGI') }}</span>
                                                </CCol>
                                                <CCol col="12" class="form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["DM"]["MDD"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_domainlist"
                                                                :flat="true"
                                                                :defaultExpandLevel="Infinity"
                                                                :clearable="false"
                                                                :placeholder="this.utilGetDDLanguage('DM.MDD')"
                                                                v-model="obj_ADomain.DI"
                                                                :disabled="obj_ADomain.I > 0"
                                                                ref="DI" />
                                                    <span class="ErrMsg">{{ ValidationNewAlternateDomainErrMsg('DI') }}</span>
                                                </CCol>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['DN'] }}<span class="required" /> :</label><br>
                                                    <CInput :placeholder="getLanguage['DM']['DN']"
                                                            size="sm"
                                                            :value="obj_ADomain.DN"
                                                            @change="v => obj_ADomain.DN = v"
                                                            maxlength="50"
                                                            :disabled="obj_ADomain.I > 0"
                                                            ref="DN"></CInput>
                                                    <span class="ErrMsg">{{ ValidationNewAlternateDomainErrMsg('DN') }}</span>
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['RT'] }} :</label>
                                                    <CButton style="width: 80px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="resetField('ART')">
                                                        <span class='plusIcon cil-reload'></span>{{this.getLanguage["DM"]["RST"]}}
                                                    </CButton><br>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="6" :placeholder="getDefaultRobotsTxt(0)" @change="TextValueChange('ART',$event)" :value="obj_ADomain.RT" :key="rtAltDKey" />
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['CNNC'] }} :</label>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="1" @change="TextValueChange('CNNC',$event)" :value="obj_ADomain.CN" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <CRow>
                                                <CCol col="12" class="form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AG"]["SUB"]}} :</label>
                                                    <treeselect :multiple="false"
                                                                :async="true"
                                                                :cacheOptions="bool_cacheOptionValue"
                                                                :load-options="loadSubBrandOptions"
                                                                :defaultOptions="ddDefaultSubBrand"
                                                                :options="ddSubBrandList2"
                                                                :disable-branch-nodes="true"
                                                                :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                                :placeholder="getLanguage['AG']['SUB']"
                                                                @input="SubAgentGroupChange"
                                                                v-model="searchSubBrand2" />
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="12" class="form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["DM"]["UCF"]}}? :</label>
                                                    <input type="checkbox" :disabled="obj_ADomain.I > 0" :checked="obj_ADomain.UCF" @change="checkUseCloudFlare">
                                                </CCol>
                                                <CCol col="12">
                                                    <label v-if="!obj_ADomain.UCF" class="col-form-label-sm inline inline60">{{this.getLanguage["DM"]["DNS"]}} :</label>
                                                    <CInput v-if="!obj_ADomain.UCF" class="inline inline60" :placeholder="getLanguage['DM']['DNS']" size="sm" :value="obj_ADomain.DNS" @change="v => obj_ADomain.DNS = v"></CInput>
                                                    <CButton v-if="!obj_ADomain.UCF" style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addAlternateDomainNameServer()">
                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                                    </CButton>

                                                    <CRow v-if="!(obj_ADomain.UCF && obj_ADomain.I == 0)" style="padding-top: 20px;display: block;">
                                                        <CCol col="12" class="form-group">
                                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                                <thead>
                                                                    <tr>
                                                                        <th v-if="!obj_ADomain.UCF" style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                                        <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                        <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="obj_ADomain.DomainNameServer == 0 || !obj_ADomain.DomainNameServer">
                                                                        <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                                                                    </tr>
                                                                    <tr v-for="(data,index) in obj_ADomain.DomainNameServer">
                                                                        <td v-if="!obj_ADomain.UCF">
                                                                            <span id="actionBtnCol">
                                                                                <i class="cil-trash" @click='removeADomainNameServer(index)'></i> <!--here Remove -->
                                                                            </span>
                                                                        </td>
                                                                        <td>{{ index+1 }}</td>
                                                                        <td>{{ data.DNS }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </CCol>
                                                    </CRow>

                                                    <CRow v-if="obj_ADomain.UCF && obj_ADomain.I > 0">
                                                        <CCol col="12" class="form-group">
                                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["CFS"]}} : {{ obj_ADomain.CFStatus }}</label>
                                                        </CCol>
                                                        <CCol v-if="obj_ADomain.CFStatus=='pending'" col="12" class="form-group">
                                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["CFCNS"]}} :</label>
                                                            <table class="custom-table custom-table-inPopUp  afb-blue">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                        <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(data,index) in obj_ADomain.CFCurNameServers">
                                                                        <td>{{ index+1 }}</td>
                                                                        <td>{{ data }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </CCol>
                                                    </CRow>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveNAlternateDomain()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                    <CButton v-if="ModuleAccessAltDomain_delete && obj_ADomain.I > 0" color="outline-dark" size="sm" @click="deleteAlternateDomain()">
                                        <span class='plusIcon cil-trash'></span>
                                        {{this.getLanguage["BTN"]["DLT"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowCD">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["DM"][obj_Domain.I > 0? "EDM": "ADM"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="overflow-x:auto">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['DN'] }}<span class="required" /> :</label><br>
                                            <CInput :placeholder="getLanguage['DM']['DN']"
                                                    size="sm"
                                                    :value="obj_Domain.DN"
                                                    @change="changeDomainName($event, obj_Domain.I)"
                                                    ref="DN"></CInput>
                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('DN') }}</span>
                                        </CCol>
                                        <CCol col="6" class="form-group" v-if="this.getUserInfo.AT < 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["AGI"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup2"
                                                              :flat="true"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                              v-model="obj_Domain.AGIT"
                                                              @input="AgentGroupChange"
                                                              :disabled="obj_Domain.I > 0"
                                                              ref="AGI" />
                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('AGI') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{getUserInfo.AT < 4? this.getLanguage["AG"]["SUB"]: this.getLanguage["AG"]["PSUB"]}}<span class="required" v-if="checkCreateDomainAccess() == 1" /> :</label>
                                            <treeselect :multiple="false"
                                                        :flat="true"
                                                        :async="true"
                                                        :cacheOptions="bool_cacheOptionValue"
                                                        :load-options="loadSubBrandOptions"
                                                        :defaultOptions="ddDefaultSubBrand"
                                                        :options="ddSubBrandList"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="getLanguage['AG']['SUB']"
                                                        @input="SubAgentGroupChange"
                                                        v-model="searchSubBrand"
                                                        :key="rtSubBrandKey"
                                                        :disabled="obj_Domain.I > 0"
                                                        ref="SAGI" />
                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('SAGI', 'SUB') }}</span>
                                        </CCol>
                                        <CCol col="2" v-if="isSubAgent">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["PAGI"]}} <span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_domain"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                        v-model="obj_Domain.PDI"
                                                        :disabled="obj_Domain.I > 0" />
                                        </CCol>

                                        <CCol col="2" v-if="isSubAgent && !isOutlet">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["RTW"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_domain"
                                                        :flat="true"
                                                        :defaultExpandLevel="Infinity"
                                                        :clearable="false"
                                                        :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                        v-model="obj_Domain.IM" />
                                        </CCol>
                                        <CCol col="1" v-if="isSubAgent">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["ESEO"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" v-model="obj_Domain.SAESEO" true-value="true" false-value="false">
                                                <span class="slider round STYLE_unlock"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="1" v-if="((obj_Domain.I == 0 && !isSubAgent) || obj_Domain.IOL == 1) && getUserInfo.AT < 4">
                                            <label class="col-form-label-sm">{{this.getLanguage["SUB"]["OLT"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" v-model="obj_Domain.IOL" :disabled="obj_Domain.I > 0" true-value="true" false-value="false">
                                                <span class="slider round STYLE_unlock"></span>
                                            </label>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="!isAgent">
                                        <CCol col="12">
                                            <span>{{ this.getLanguage['DM']['DMINFO'] }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3" v-if="!isAgent">
                                            <label class="col-form-label-sm inline inline60">{{this.getLanguage["DM"]["DNS"]}} :</label>
                                            <CInput class="inline inline60" :placeholder="getLanguage['DM']['DNS']" size="sm" :value="obj_Domain.DNS" @change="v => obj_Domain.DNS = v"></CInput>
                                            <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addPDomainNameServer()">
                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                            </CButton>
                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_Domain.DomainNameServer == 0 || !obj_Domain.DomainNameServer">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_Domain.DomainNameServer">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <span class="custom_tooltip">
                                                                    <i class="cil-trash" @click='removePDomainNameServer(index)'></i>
                                                                    <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                </span>
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ data.DNS }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                        </CCol>
                                        <CCol col="3" v-if="!isAgent">
                                            <label class="col-form-label-sm inline inline60">{{this.getLanguage["DM"]["WL"]}} :</label>
                                            <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addMyIP()">
                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["DM"]["MIP"]}}
                                            </CButton>
                                            <CInput class="inline inline60" :placeholder="getLanguage['DM']['WL']" size="sm" :value="obj_Domain.MIP" @change="v => obj_Domain.MIP = v"></CInput>
                                            <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addMaintenanceIP()">
                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                            </CButton>
                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th>{{this.getLanguage['DM']['WL']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_Domain.MaintenanceIP == 0 || !obj_Domain.MaintenanceIP">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_Domain.MaintenanceIP">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <span class="custom_tooltip">
                                                                    <i class="cil-trash" @click='removeMaintenanceIP(index)'></i>
                                                                    <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                </span>
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ data.MIP }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                        </CCol>
                                        <CCol col="6" v-if="isAgent">
                                            <label class="col-form-label-sm inline inline60">{{this.getLanguage["DM"]["DNS"]}} :</label>
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                <td colspan="100%" v-if="obj_Domain.DomainNameServer == 0 || !obj_Domain.DomainNameServer">{{this.getLanguage['GL']['NR']}}</td>
                                                <tr v-for="(data,index) in obj_Domain.DomainNameServer">
                                                    <td>{{ index+1 }}</td>
                                                    <td>{{ data.DNS }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                        <CCol col="6">
                                            <CRow>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm">{{this.getLanguage["DM"]["SR"]}} :</label>
                                                    <treeselect :multiple="true"
                                                                :options="dd_seorobots"
                                                                :clearable="false"
                                                                :defaultExpandLevel="1"
                                                                valueConsistsOf="LEAF_PRIORITY"
                                                                :placeholder="getLanguage['DM']['SR']"
                                                                v-model="obj_Domain.SRT" />
                                                </CCol>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['RT'] }} :</label>
                                                    <CButton style="width: 80px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="resetField('RT')">
                                                        <span class='plusIcon cil-reload'></span>{{this.getLanguage["DM"]["RST"]}}
                                                    </CButton><br>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="5" :placeholder="getDefaultRobotsTxt(1)" @change="TextValueChange('RTD',$event)" :value="obj_Domain.RT" :key="rtKey" />

                                                </CCol>
                                            </CRow>

                                            <CRow>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['CNNC'] }} :</label>

                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="1" @change="TextValueChange('CNT',$event)" :value="obj_Domain.CN" />
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['DIP'] }} :</label>
                                                    <CInput :placeholder="getLanguage['DM']['DIP']" size="sm" :value="obj_Domain.SIP" @change="v => obj_Domain.SIP = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm inline inline80">{{this.getLanguage["DM"]["ALTDM"]}} :</label>
                                            <!--<CButton v-if="!obj_Domain.DALT || obj_Domain.DALT.length < 15" color="outline-dark" size="sm" class="btn-small inline inline20" @click="addAlternateDomain()">
                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                            </CButton>-->

                                            <CRow>
                                                <CCol>
                                                    <table class="custom-table custom-table-inPopUp afb-blue" :key="altdmKey">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 120px; max-width: 320px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                                <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                <th>{{this.getLanguage['DM']['DN']}} ({{this.getLanguage["DM"]["DNS"]}})</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-if="!obj_Domain.DALT || obj_Domain.DALT.length == 0">
                                                                <td colspan="3">{{this.getLanguage['GL']['NR']}}</td>
                                                            </tr>
                                                            <tr v-for="(data,index) in obj_Domain.DALT">
                                                                <td>
                                                                    <span class="custom_tooltip">
                                                                        <i class="cil-color-border" @click='editAlternateDomain(index)'></i>
                                                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                                    </span>
                                                                    <span class="custom_tooltip">
                                                                        <i class="cil-trash" @click='removeAlternateDomain(index)'></i>
                                                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                    </span>
                                                                </td>
                                                                <td>{{ index+1 }}</td>
                                                                <td>
                                                                    {{ data.DN }}
                                                                    <i v-if="data.UCF" class="cib-cloudflare"></i>
                                                                    <span v-if="data.DNS != ''">({{ displayDNSLine(data.DNS) }})</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                    <!-- <div v-if="!isAgent">
                                    <CRow>
                                        <CCol col="6">
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm full-width">{{this.getLanguage["DM"]["TH"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_theme"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['DM']['TH']"
                                                        :max-height="200"
                                                        v-model="obj_Domain.TI" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm inline inline50">{{this.getLanguage['DM']['SMS']}}<span class="required" /> : </label>
                                            <label v-if="obj_Domain.SMSV > 1" class="col-form-label-sm inline inline50">{{this.getLanguage['DM']['SMSVP']}}<span class="required" /> : </label>
                                            <div v-else class="inline inline50"></div>
                                            <treeselect class="inline inline50"
                                                        :multiple="false"
                                                        :options="dd_smsverification"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['DM']['SMS']"
                                                        @input="SMSVerificationChange"
                                                        v-model="obj_Domain.SMSV" />
                                            <treeselect class="inline inline50"
                                                        :multiple="true"
                                                        :options="dd_verificationpage"
                                                        :defaultExpandLevel="1"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['DM']['SMSVP']"
                                                        v-model="obj_Domain.SMSVPages"
                                                        v-if="obj_Domain.SMSV > 1" />
                                            <span class="ErrMsg inline inline50"></span>
                                            <span class="ErrMsg inline inline50">{{ ValidationDomainErrMsg('SMSVP') }}</span>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm inline inline50">{{this.getLanguage['DM']['EV']}}<span class="required" /> :</label>
                                            <label v-if="obj_Domain.EV > 1" class="col-form-label-sm inline inline50">{{this.getLanguage['DM']['EVP']}} : </label>
                                            <div v-else class="inline inline50"></div>
                                            <treeselect class="inline inline50"
                                                        :multiple="false"
                                                        :options="dd_emailverification"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['DM']['EV']"
                                                        @input="EmailVerificationChange"
                                                        v-model="obj_Domain.EV" />
                                            <treeselect class="inline inline50"
                                                        :multiple="true"
                                                        :options="dd_verificationpage"
                                                        :defaultExpandLevel="1"
                                                        valueConsistsOf="LEAF_PRIORITY"
                                                        :clearable="false"
                                                        :placeholder="getLanguage['DM']['EVP']"
                                                        v-model="obj_Domain.EVPages"
                                                        v-if="obj_Domain.EV > 1" />
                                            <span class="ErrMsg inline inline50"></span>
                                            <span class="ErrMsg inline inline50">{{ ValidationDomainErrMsg('EVP') }}</span>
                                        </CCol>
                                    </CRow>
                                </div> -->
                                    <CRow>
                                        <CCol col="4">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["RM"]}} :</label>
                                            <textarea v-shortkey.avoid vertical="" rows="3" class="form-control form-control-sm" :value="obj_Domain.R" @change="TextValueChange('R',$event)" />
                                        </CCol>
                                        <CCol col="2">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["MT"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" v-model="obj_Domain.RS" true-value="1" false-value="2">
                                                <span class="slider round STYLE_unlock"></span>
                                            </label>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="3" v-if="obj_Domain.I > 0">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["ADN"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :options="dd_dofs"
                                                        :placeholder="this.utilGetDDLanguage('DM.ADN')"
                                                        v-model="obj_Domain.ADI" />
                                        </CCol>
                                        <CCol col="3">
                                            <label class="col-form-label-sm">{{getLanguage['DM']['AMPSU'] }} :</label>
                                            <CInput size="sm" :value="obj_Domain.AMPSU" @change="v => obj_Domain.AMPSU = v"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="!isSubAgent">
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["SL"]}} (300 x 130):</label>
                                            <CTabs variant='tabs' id="imageURLTab">
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_Domain.SLBL === false ? true: false">
                                                    <img v-if="obj_Domain['SL'] != null && obj_Domain['SL'] != ''"
                                                         width="300"
                                                         height="130"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Domain['SL'])" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileSelected" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFile === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFile.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 300 x 130</label>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_Domain.SLBL === true ? true: false">
                                                    <img v-if="obj_Domain['SL'] != null && obj_Domain['SL'] != ''"
                                                         width="300"
                                                         height="130"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Domain['SL'])" />
                                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                        </div>
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_Domain.LOGOByLink">
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 300 x 130</label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["SI"]}} (.ico)(25 X 25):</label>
                                            <CTabs variant='tabs' id="imageURLTab2">
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_Domain.SIBL === false ? true: false">
                                                    <img v-if="obj_Domain['SI'] != null && obj_Domain['SI'] != ''"
                                                         width="auto"
                                                         height="130"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Domain['SI'])" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileIcoSelected" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFileIco === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFileIco.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 25 X 25</label>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_Domain.SIBL === true ? true: false">
                                                    <img v-if="obj_Domain['SI'] != null && obj_Domain['SI'] != ''"
                                                         width="auto"
                                                         height="130"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Domain['SI'])" />
                                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                        </div>
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_Domain.ICONByLink">
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 25 X 25</label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="!isSubAgent">
                                        <CCol col="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["MSL"]}} (100 x 100):</label>
                                            <CTabs variant='tabs' id="imageURLTab3">
                                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_Domain.MSLBL === false ? true: false">
                                                    <img v-if="obj_Domain['MSL'] != null && obj_Domain['MSL'] != ''"
                                                         width="100"
                                                         height="100"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Domain['MSL'])" />
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileMLogoSelected" required>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFileMsl === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFileMsl.name}}</label>
                                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 100 x 100</label>
                                                </CTab>
                                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_Domain.MSLBL === true ? true: false">
                                                    <img v-if="obj_Domain['MSL'] != null && obj_Domain['MSL'] != ''"
                                                         width="100"
                                                         height="100"
                                                         class="mb-2"
                                                         :src="getImgUrl(obj_Domain['MSL'])" />
                                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                        </div>
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_Domain.MobileLOGOByLink">
                                                    </div>
                                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 100 x 100</label>
                                                </CTab>
                                            </CTabs>
                                        </CCol>
                                    </CRow>
                                    <div v-if="!isAgent && !isSubAgent">
                                        <!-- <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["DM"]["SLBL"]}} :</label>
                                            <label class="switch" style="float: right;">
                                                <input v-model="obj_Domain.SLBL" type="checkbox" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["DM"]["SIBL"]}} :</label>
                                            <label class="switch" style="float: right;">
                                                <input v-model="obj_Domain.SIBL" type="checkbox" />
                                                <span class="slider round"></span>
                                            </label>
                                        </CCol>
                                    </CRow> -->
                                        <br />
                                        <CRow>
                                            <CCol style="width:auto;max-width:unset">
                                                <CCard>
                                                    <CCardHeader>
                                                        <Strong>{{this.getLanguage["DM"]["S"]}}</Strong>
                                                    </CCardHeader>
                                                    <CCardBody>
                                                        <table cellpadding="3px" style="border-collapse:unset" :key="rtDomainSettingKey">
                                                            <tr>
                                                                <td style="vertical-align:top;min-width:70px">
                                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('L') }}</span>
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 150px">
                                                                    {{this.getLanguage["DM"]["L"]}}<span class="required" />
                                                                </td>
                                                                <td class="text-center" style="vertical-align: top; min-width: 150px">
                                                                    {{this.getLanguage["DM"]["DL"]}}<span class="required" />
                                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('DL') }}</span>
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 200px">
                                                                    {{this.getLanguage["DM"]["C"]}}<span class="required" />
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 250px">
                                                                    {{this.getLanguage["DM"]["T"]}}<span class="required" />
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 250px">
                                                                    {{this.getLanguage["DM"]["MTEP"]}}
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 350px">
                                                                    {{this.getLanguage["DM"]["GP"]}}<span class="required" />
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 150px">
                                                                    {{this.getLanguage["DM"]["AFB1188SW"]}}
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 150px">
                                                                    {{this.getLanguage["DM"]["AFB1188SM"]}}
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 150px">
                                                                    {{this.getLanguage["DM"]["AFB1188OS"]}}
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 150px">
                                                                    {{this.getLanguage["DM"]["AFB1188OM"]}}
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 200px" v-if="getUserInfo.AT == 0">
                                                                    {{this.getLanguage["DM"]["AFB1188SBAPI"]}}
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 200px">
                                                                    {{this.getLanguage["DM"]["CURL"]}}
                                                                    <br /><span class="amountNote">{{getLanguage["DM"]["EX"]}}: Custom/GoodGame/</span>
                                                                </td>
                                                                <td style="vertical-align: top; min-width: 200px">
                                                                    {{this.getLanguage["DM"]["GCURL"]}}
                                                                    <br /><span class="amountNote">{{getLanguage["DM"]["EX"]}}: Custom/GoodGame/</span>
                                                                </td>
                                                            </tr>
                                                            <tr v-for="(setting, index) in obj_Domain.DS" :key="setting.L">
                                                                <td class="chk-container" style="vertical-align:top">
                                                                    <input type="checkbox"
                                                                           @click="tickSettingCheckbox($event, setting)"
                                                                           :disabled="!setting.LE || !bool_languageloaded"
                                                                           v-model="setting.TC"
                                                                           ref="L" />
                                                                </td>
                                                                <td class="lbl-container" style="vertical-align:top">
                                                                    {{ setting.LN }}
                                                                </td>
                                                                <td class="text-center" style="vertical-align:top">
                                                                    <input type="radio"
                                                                           name="defLanguage"
                                                                           :value="setting.L"
                                                                           :disabled="!setting.TC"
                                                                           v-model="obj_Domain.DL"
                                                                           ref="DL" />
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <treeselect :multiple="true"
                                                                                :options="dd_currency"
                                                                                :defaultExpandLevel="1"
                                                                                valueConsistsOf="LEAF_PRIORITY"
                                                                                :disabled="!setting.TC || !bool_currencyloaded"
                                                                                :placeholder="getLanguage['DM']['C']"
                                                                                v-model="setting.CurrencyCodes"
                                                                                ref="DS.$each.CC" />
                                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('CC', 'C', index) }}</span>
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_template"
                                                                                :disabled="!setting.TC"
                                                                                :placeholder="getLanguage['DM']['T']"
                                                                                @input="TemplateChange($event,index)"
                                                                                v-model="setting.TI"
                                                                                ref="DS.$each.TI" />
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_templateskins[setting.TI]"
                                                                                :placeholder="getLanguage['DM']['T']"
                                                                                v-model="setting.TSI"
                                                                                v-if="setting.TI > 0" />
                                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('TI', 'T', index) }}</span>
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_mtemplate"
                                                                                :disabled="!setting.TC"
                                                                                :placeholder="getLanguage['DM']['T']"
                                                                                @input="MobileTemplateChange($event,index)"
                                                                                v-model="setting.MTI" />
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_mtemplateskins[setting.MTI]"
                                                                                :placeholder="getLanguage['DM']['T']"
                                                                                v-model="setting.MTSI"
                                                                                v-if="setting.MTI > 0" />
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <div class="dd-container">
                                                                        <treeselect :multiple="true"
                                                                                    :options="dd_gameprovider"
                                                                                    valueConsistsOf="LEAF_PRIORITY"
                                                                                    :defaultExpandLevel="2"
                                                                                    :placeholder="getLanguage['DM']['GP']"
                                                                                    v-model="setting.GameProviderIdS"
                                                                                    :disabled="!setting.TC || !bool_gameloaded"
                                                                                    ref="DS.$each.GPI" />
                                                                        <span class="ErrMsg">{{ ValidationDomainErrMsg('GPI', 'GP', index) }}</span>
                                                                    </div>
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_1188SW"
                                                                                :disabled="!setting.TC"
                                                                                v-model="setting.AFB1188SW" />
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_1188SM"
                                                                                :disabled="!setting.TC"
                                                                                v-model="setting.AFB1188SM" />
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_1188OS"
                                                                                :disabled="!setting.TC"
                                                                                v-model="setting.AFB1188OS" />
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_1188OM"
                                                                                :disabled="!setting.TC"
                                                                                v-model="setting.AFB1188OM" />
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top" v-if="getUserInfo.AT == 0">
                                                                    <treeselect :multiple="false"
                                                                                :options="dd_1188API"
                                                                                :disabled="!setting.TC"
                                                                                v-model="obj_Domain.AFB1188SBAPI" />
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <div class="form-group" style="margin-bottom:1rem !important">
                                                                        <input type="text" :placeholder="getLanguage['DM']['CURL']" v-model="setting.CURL" class="form-control form-control-sm" />
                                                                    </div>
                                                                </td>
                                                                <td class="dd-container" style="vertical-align:top">
                                                                    <div class="form-group" style="margin-bottom:1rem !important">
                                                                        <input type="text" :placeholder="getLanguage['DM']['GCURL']" v-model="setting.GCURL" class="form-control form-control-sm" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <!--<CRow>
                                                        <CCol col="1"><span class="ErrMsg">{{ ValidationDomainErrMsg('L') }}</span></CCol>
                                                        <CCol col="1">{{this.getLanguage["DM"]["L"]}}<span class="required" /></CCol>
                                                        <CCol col="1" class="text-center">
                                                            {{this.getLanguage["DM"]["DL"]}}<span class="required" />
                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('DL') }}</span>
                                                        </CCol>
                                                        <CCol col="2">{{this.getLanguage["DM"]["C"]}}<span class="required" /></CCol>
                                                        <CCol col="2">{{this.getLanguage["DM"]["T"]}}<span class="required" /></CCol>
                                                        <CCol col="3">{{this.getLanguage["DM"]["GP"]}}<span class="required" /></CCol>
                                                        <CCol col="2">
                                                            {{this.getLanguage["DM"]["CURL"]}}
                                                        {{this.getLanguage["DM"]["GCURL"]}}
                                                            </br><span class="amountNote">{{getLanguage["DM"]["EX"]}}: Custom/GoodGame/</span>
                                                        </CCol>
                                                    </CRow>-->
                                                        <!--<CRow v-for="(setting, index) in obj_Domain.DS" :key="setting.L">
                                                        <CCol col="1" class="chk-container">
                                                            <input type="checkbox"
                                                                   @click="tickSettingCheckbox($event, setting)"
                                                                   :disabled="!setting.LE || !bool_languageloaded"
                                                                   v-model="setting.TC" />
                                                        </CCol>
                                                        <CCol col="1" class="lbl-container">
                                                            {{ setting.LN }}
                                                        </CCol>
                                                        <CCol col="1" class="text-center">
                                                            <input type="radio"
                                                                   name="defLanguage"
                                                                   :value="setting.L"
                                                                   :disabled="!setting.TC"
                                                                   v-model="obj_Domain.DL" />
                                                        </CCol>
                                                        <CCol col="2" class="dd-container">
                                                            <treeselect :multiple="true"
                                                                        :options="dd_currency"
                                                                        :defaultExpandLevel="1"
                                                                        valueConsistsOf="LEAF_PRIORITY"
                                                                        :disabled="!setting.TC || !bool_currencyloaded"
                                                                        :placeholder="getLanguage['DM']['C']"
                                                                        v-model="setting.CurrencyCodes" />
                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('CC', 'C', index) }}</span>
                                                        </CCol>
                                                        <CCol col="2" class="dd-container">
                                                            <treeselect :multiple="false"
                                                                        :options="dd_template"
                                                                        :disabled="!setting.TC"
                                                                        :placeholder="getLanguage['DM']['T']"
                                                                        @input="TemplateChange($event,index)"
                                                                        v-model="setting.TI" />
                                                            <treeselect :multiple="false"
                                                                        :options="dd_templateskins[setting.TI]"
                                                                        :placeholder="getLanguage['DM']['T']"
                                                                        v-model="setting.TSI"
                                                                        v-if="setting.TI > 0" />
                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('TI', 'T', index) }}</span>
                                                        </CCol>
                                                        <CCol col="3" class="dd-container">
                                                            <treeselect :multiple="true"
                                                                        :options="dd_gameprovider"
                                                                        valueConsistsOf="LEAF_PRIORITY"
                                                                        :defaultExpandLevel="2"
                                                                        :placeholder="getLanguage['DM']['GP']"
                                                                        v-model="setting.GameProviderIdS"
                                                                        :disabled="!setting.TC || !bool_gameloaded" />
                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('GPI', 'GP', index) }}</span>
                                                        </CCol>
                                                        <CCol col="2" class="dd-container">
                                                            <CInput :placeholder="getLanguage['DM']['CURL']" size="sm" v-model="setting.CURL" :value="setting.CURL"></CInput>
                                                        </CCol>
                                                    </CRow>-->
                                                    </CCardBody>
                                                </CCard>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <div style="text-align:center;padding-top:10px">
                                    <CButton color="outline-info" size="sm" @click="saveDomain()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isEditALtDM">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['DM']['ALTDM']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="cancelAlternateDomain">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['DN'] }}<span class="required" /> :</label><br>
                                            <CInput :placeholder="getLanguage['DM']['DN']" size="sm" :value="obj_ALDM.DN" @change="v => obj_ALDM.DN = v" maxlength="50" :disabled="obj_ALDM.UCF" ref="DN"></CInput>
                                            <span class="ErrMsg">{{ ValidationAlternateDomainErrMsg('DN') }}</span>
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['RT'] }} :</label>
                                            <CButton style="width: 80px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="resetField('CRT')">
                                                <span class='plusIcon cil-reload'></span>{{this.getLanguage["DM"]["RST"]}}
                                            </CButton><br>
                                            <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="6" :placeholder="getDefaultRobotsTxt(0)" @change="TextValueChange('RTAD',$event)" :value="obj_ALDM.RT" :key="rtAltKey" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['CNNC'] }} :</label>
                                            <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="1" @change="TextValueChange('CNTA',$event)" :value="obj_ALDM.CN" />

                                            <label v-if="!obj_ALDM.UCF" class="col-form-label-sm inline inline60">{{this.getLanguage["DM"]["DNS"]}} :</label>
                                            <CInput v-if="!obj_ALDM.UCF" class="inline inline60" :placeholder="getLanguage['DM']['DNS']" size="sm" @change="v => obj_ALDM.DNS = v"></CInput>
                                            <CButton v-if="!obj_ALDM.UCF" style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addADomainNameServer()">
                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                            </CButton>

                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th v-if="!obj_ALDM.UCF" style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_ALDM.DomainNameServer == 0 || !obj_ALDM.DomainNameServer">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_ALDM.DomainNameServer">
                                                        <td v-if="!obj_ALDM.UCF">
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removeALDDomainNameServer(index)'></i> <!--here Remove -->
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ data.DNS }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveAlternateDomain()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'AGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["AGI"] }}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'SAGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["SAB"] }}
                                                <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MAGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["MAB"] }}
                                                <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'DN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["CMS"]["DN"] }}
                                                <i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ALDN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["ALTDM"] }}
                                            </template>
                                            <template v-else-if="header == 'ST'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["S"] }} ({{ getLanguage["DM"]["L"] }} > {{ getLanguage["DM"]["C"] }})
                                            </template>
                                            <template v-else-if="header == 'WLIP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["WL"] }}
                                            </template>
                                            <template v-else-if="header == 'RM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["RM"] }}
                                                <i @click="setSortTable('R')" :class="setSortLogo('R')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'RB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["SR"] }}
                                                <i @click="setSortTable('SEOR')" :class="setSortLogo('SEOR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["DM"]["CT"] }}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'UB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["CPR"]["UB"] }}
                                            </template>
                                            <template v-else-if="header == 'UTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["UTS"] }}
                                                <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{getLanguage["DM"]["MD"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addDomain()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                        <CButton size="sm" color="outline-info" v-if="ModuleAccessAltDomain_add" @click="OpenAlternateDomain()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AAD"]}}</CButton>
                        <CButton size="sm" color="outline-info" v-if="getUserInfo.AT == 0 && checkModuleAccess2(constAccessType.edit)" @click="clearCache({ I: 0, AGI: 0})"><span class="plusIcon cil-sync"></span>{{getLanguage["BTN"]["CCACHE"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["DM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                  v-model="arr_FV['AGI']"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class="searchLabel">{{this.getLanguage["AG"]["SUB"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubBrandList3"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            v-model="arr_FV['SAGAGI']"
                                            :key="rtSubBrandKey"
                                            openDirection="below"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <!--<div class='searchCol'>
                            <span class='searchLabel'>{{//this.getLanguage["DM"]["D"]}} :</span>
                            <CInput size="sm" :value="arr_FV.DN" @change="v => arr_FV.DN = v"></CInput>
                        </div>-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["CMS"]["DN"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_dn"
                                            :placeholder="this.utilGetDDLanguage('MTA.DN')"
                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                            v-model="arr_FV.DI" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["DM"]["L"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_language"
                                            :placeholder="this.utilGetDDLanguage('DM.L')"
                                            v-model="arr_FV['L']"
                                            :limit="1"
                                            :limitText="count => `+${count}`">
                                    <div slot="value-label" slot-scope="{ node }">
                                        <span v-for="(data,index) in dd_language" v-if="node.id==data.id" class="flagClass" :class="mapLanguageFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                    <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                        <span v-for="(data,index) in dd_language" v-if="node.id==data.id" class="flagClass" :class="mapLanguageFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                </treeselect>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch();" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['DM']['MDL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'AGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["SAB"] }}
                                        <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["MAB"] }}
                                        <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'DN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["CMS"]["DN"] }}
                                        <i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ALDN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["ALTDM"] }}
                                    </template>
                                    <template v-else-if="header == 'ST'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["S"] }} ({{ getLanguage["DM"]["L"] }} > {{ getLanguage["DM"]["C"] }})
                                    </template>
                                    <template v-else-if="header == 'WLIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["WL"] }}
                                    </template>
                                    <template v-else-if="header == 'RM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["RM"] }}
                                        <i @click="setSortTable('R')" :class="setSortLogo('R')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["SR"] }}
                                        <i @click="setSortTable('SEOR')" :class="setSortLogo('SEOR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["CT"] }}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["CPR"]["UB"] }}
                                    </template>
                                    <template v-else-if="header == 'UTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["UTS"] }}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'AGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'SAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["SAB"] }}
                                        <i @click="setSortTable('SAGN')" :class="setSortLogo('SAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MAGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["MAB"] }}
                                        <i @click="setSortTable('MAGN')" :class="setSortLogo('MAGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'DN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["CMS"]["DN"] }}
                                        <i @click="setSortTable('DN')" :class="setSortLogo('DN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ALDN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["ALTDM"] }}
                                    </template>
                                    <template v-else-if="header == 'ST'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["S"] }} ({{ getLanguage["DM"]["L"] }} > {{ getLanguage["DM"]["C"] }})
                                    </template>
                                    <template v-else-if="header == 'WLIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["WL"] }}
                                    </template>
                                    <template v-else-if="header == 'RM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["RM"] }}
                                        <i @click="setSortTable('R')" :class="setSortLogo('R')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["SR"] }}
                                        <i @click="setSortTable('SEOR')" :class="setSortLogo('SEOR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["DM"]["CT"] }}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["CPR"]["UB"] }}
                                    </template>
                                    <template v-else-if="header == 'UTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["UTS"] }}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Domain.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Domain">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                    <span id="actionBtnCol">
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-trash" @click="removeDomain(data)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)">
                                            <i class="cil-trash" @click="removeDomain(data)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)">
                                            <i class="cil-trash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-color-border" @click="editDomain(data.I)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)">
                                            <i class="cil-color-border" @click="editDomain(data.I)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)">
                                            <i class="cil-color-border"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="ModuleAccessAltDomain_add && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-link-alt" @click="OpenAlternateDomain(data.AGI, data.I)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["AAD"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="ModuleAccessAltDomain_add && (isSENS == 1 && data.AAGI == curAGI && data.AGI != curAGI)">
                                            <i class="cil-link-alt" @click="OpenAlternateDomain(data.AGI, data.I)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["AAD"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="ModuleAccessAltDomain_add && (isSENS == 1 && data.AGI != curAGI && data.AAGI != curAGI)">
                                            <i class="cil-link-alt"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["AAD"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-sync" @click="clearCache(data)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["CCACHE"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'AGN'">
                                    {{ data.GN }} ({{ data.PC }})
                                </template>
                                <template v-else-if="header == 'SAGN'">
                                    {{ data.SAGN }} ({{ data.SAPC }})
                                </template>
                                <template v-else-if="header == 'MAGN'">
                                    {{ data.MAGN }} ({{ data.MAPC }})
                                </template>
                                <template v-else-if="header == 'DN'">
                                    <div v-if="data.RS==1" class="custom_tooltip">
                                        <span class="maintenance">{{ data.DN }}</span>
                                        <span class="tooltiptext">{{ getLanguage["DM"]["MT"] }}</span>
                                    </div>
                                    <div v-else>{{ data.DN }}</div>
                                </template>
                                <template v-else-if="header == 'ALDN'">
                                    <span v-if="data.DomainAlternate!=null && data.DomainAlternate.length != 0">
                                        <span v-if="ModuleAccessAltDomain_edit && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="grid-line edit-link" v-for="adn in data.DomainAlternate" @click="EditAlternateDomain(adn.I)">
                                            {{ adn.DN }}
                                            <i v-if="adn.UCF" class="cib-cloudflare"></i>
                                        </span>
                                        <span v-if="ModuleAccessAltDomain_edit && (isSENS == 1 && data.AGI != curAGI)" class="grid-line edit-link" v-for="adn in data.DomainAlternate">
                                            {{ adn.DN }}
                                            <i v-if="adn.UCF" class="cib-cloudflare"></i>
                                        </span>
                                        <span v-if="!ModuleAccessAltDomain_edit && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="grid-line" v-for="adn in data.DomainAlternate">
                                            {{ adn.DN }}
                                            <i v-if="adn.UCF" class="cib-cloudflare"></i>
                                        </span>
                                        <span v-if="!ModuleAccessAltDomain_edit && (isSENS == 1 && data.AGI != curAGI)" class="grid-line" v-for="adn in data.DomainAlternate">
                                            {{ adn.DN }}
                                            <i v-if="adn.UCF" class="cib-cloudflare"></i>
                                        </span>
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'ST'">
                                    <div v-for="(setting,index) in data.DomainSettings" class="grid-line" :class="boldDefaultLanguage(data.DL, setting.L)">
                                        <span>{{ setting.LN }}</span>
                                        <span>{{ setting.CC }}</span>
                                        <!--<span class="item-tp">{{ //setting.TN }}</span>-->
                                    </div>
                                </template>
                                <template v-else-if="header == 'WLIP'">
                                    <span v-if="data.MaintenanceIP != ''">
                                        <span class="grid-line" v-for="mip in data.MaintenanceIP">{{ mip }}</span>
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'RM'">
                                    <span v-if="data.R != ''">{{ substrContent(data.R,25) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'RB'">
                                    <span v-if="data.SEOR != ''">{{ substrContent(data.SEOR,25) }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    {{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'UB'">
                                    {{ data.UB }}
                                </template>
                                <template v-else-if="header == 'UTS'">
                                    {{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constSEORobots, constSMSVerification, constEmailVerification, constVerificationPage, constAFB1188SkinW, constAFB1188SkinM, constAFB1188OddsStyle, constAFB1188OddsMode, constAFB1188SportbookLaunchAPI, constHouseBrand } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import DateRangePicker from 'vue2-daterange-picker';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, requiredIf } from 'vuelidate/lib/validators';
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import $ from 'jquery'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    // import Vue from 'vue'
    // Vue.use(require('vue-shortkey'), { prevent: ['.noautoenter'] })

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker,
            Sortable,
            draggable
        },
        data() {
            return {
                isAgent: false,
                isSubAgent: false,
                isOutlet: false,
                isChangeDomainName: false,
                //sensBtn: true,
                OldDomainName: "",
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                arr_FV: {
                    "DI": null,
                    "L": [],
                    "AGI": null,
                    "SAGAGI": null,
                    "DR": {
                        startDate: "",
                        endDate: ""
                    },
                }, //Filter Value
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                arr_Domain: [],
                obj_Domain: {
                    "I": 0,
                    "RS": 2,
                    "DN": "",
                    "L": "",
                    "DL": null,
                    "R": "",
                    "AGIT": null,
                    "AGI": "",
                    "SRT": null,
                    "SEOR": "",
                    "MIP": "",
                    "DNS": "",
                    "DS": [],
                    "TI": 1,
                    "SMSV": "1",
                    "SMSVP": "",
                    "SMSVPages": null,
                    "EV": "1",
                    "EVP": "",
                    "EVPages": null,
                    "SL": "",
                    "RSL": false,
                    "SLBL": false,
                    "SI": "",
                    "RSI": false,
                    "SIBL": false,
                    "ICONByLink": "",
                    "LOGOByLink": "",
                    "MaintenanceIP": [],
                    "DomainNameServer": [],
                    "ALD": null,
                    "ADI": null,
                    "CN": "",
                    "SIP": "",
                    "AMPSU": null,
                    "AFB1188SBAPI": null,
                    "MSL": "",
                    "MSLBL": false,
                    "RMSL": false,
                    "MobileLOGOByLink": ""

                },
                bool_isAD: false,
                bool_fullScreen: loadingFullScreen,
                arr_ADomain: [],
                obj_ADomain: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "DI": null,
                    "DN": "",
                    "DNS": "",
                    "DomainNameServer": [],
                    "ADI": null,
                    "CN": "",
                    "UCF": true
                },
                bool_holSLBL: false,
                bool_holSIBL: false,
                dd_agentgroup: [],
                dd_agentgroup2: [],
                dd_agentgroup3: [],
                dd_domainlist: [],
                dd_domain: [],
                dd_dofs: [],
                dd_language: [],
                bool_languageloaded: false,
                dd_template: [],
                dd_templateskins: [],
                dd_mtemplate: [],
                dd_mtemplateskins: [],
                dd_currency: [],
                bool_currencyloaded: false,
                dd_gameprovider: [],
                bool_gameloaded: false,
                bool_domainCV: false,
                dd_seorobots: [],
                dd_theme: [],
                dd_smsverification: [],
                dd_emailverification: [],
                dd_verificationpage: [],
                constAccessType: constAccessType,
                selectedFile: null,
                selectedFileIco: null,
                obj_MIP: {
                    MIP: null,
                },
                obj_DNS: {
                    DNS: null,
                },
                rtKey: 0,
                altdmKey: 0,
                obj_ALDM: null,
                bool_isEditALtDM: false,
                rtAltKey: 0,
                rtSubBrandKey: 0,
                bool_altDomainCV: false,
                dd_1188SW: [],
                dd_1188SM: [],
                dd_1188OS: [],
                dd_1188OM: [],
                dd_1188API: [],
                rtAltDKey: 0,
                bool_ADomainCV: false,
                ModuleAccessAltDomain_add: false,
                ModuleAccessAltDomain_edit: false,
                ModuleAccessAltDomain_delete: false,
                searchSubBrand: null,   //SubBrand AGI
                searchSubBrand2: null,   //SubBrand AGI
                ddSubBrandList: [],
                ddSubBrandList2: [],
                ddSubBrandList3: [],
                ddDefaultSubBrand: null,    //Defauld DD for Sub Brand
                bool_cacheOptionValue: false,
                rtDomainSettingKey: 0,
                dd_dn: [],
                filter_agi: null,
                defaultReportHeaders: ['NO', 'ACT', 'AGN', 'SAGN', 'MAGN', 'DN', 'ALDN', 'ST', 'WLIP', 'RM', 'RB', 'CTS', 'UB', 'UTS'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_holMSLBL: false,
                selectedFileMsl: null,
                bool_isDDMV: false,
                constHouseBrand: constHouseBrand,
            }
        },
        validations: {
            obj_ALDM: {
                DN: { required }
            },
            obj_Domain: {
                DN: { required },
                AGI: { required },
                L: {
                    required: requiredIf(function (vm) {
                        return !this.isSubAgent;
                    })
                },
                DL: {
                    required: requiredIf(function (vm) {
                        return !this.isSubAgent && vm.L != null && vm.L.length > 0;
                    }),
                },
                SMSVP: {
                    required: requiredIf(function (vm) {
                        return vm.SMSV == 2;
                    }),
                },
                EVP: {
                    required: requiredIf(function (vm) {
                        return vm.EV == 2;
                    }),
                },
                DS: {
                    $each: {
                        CC: {
                            required: requiredIf(function (vm) {
                                return vm.TC;
                            }),
                        },
                        TI: {
                            required: requiredIf(function (vm) {
                                return vm.TC;
                            }),
                        },
                        GPI: {
                            required: requiredIf(function (vm) {
                                return vm.TC;
                            }),
                        },
                    }
                }
            },
            obj_ADomain: {
                AGI: { required },
                DI: { required },
                DN: { required },
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_domainCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            searchSubBrand() {
                this.bool_cacheOptionValue = true;
            },
            searchSubBrand2() {
                this.bool_cacheOptionValue = true;
            },
            getLanguage() {
                this.getDomainList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/CreateDomain`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.delete))) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/CreateDomain/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            changeDomainName(event, isEdit) {
                this.obj_Domain.DN = event.replace(/\s/g, "").toLowerCase();
                this.obj_Domain.DN = this.findChar(this.obj_Domain.DN, this.obj_Domain.DN.length);

                if (isEdit > 0) {
                    if (this.OldDomainName != this.obj_Domain.DN) {
                        this.isChangeDomainName = true;
                    }
                    else {
                        this.isChangeDomainName = false;
                    }
                }
                else {
                    this.isChangeDomainName = false;
                }
            },
            hasLogo() {
                if (this.obj_Domain.SL != null && this.obj_Domain.SL != '' && !this.obj_Domain.RSL && this.obj_Domain.SLBL == this.bool_holSLBL) {
                    return true;
                }
                else {
                    return false;
                }
            },
            removeLogo() {
                this.obj_Domain.RSL = true;
                this.$forceUpdate();
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event);
                if (!this.bool_holSLBL) { // if choose local file
                    this.obj_Domain.RSL = true;
                }

            },
            hasLogoIco() {
                if (this.obj_Domain.SI != null && this.obj_Domain.SI != '' && !this.obj_Domain.RSI && this.obj_Domain.SIBL == this.bool_holSIBL) {
                    return true;
                }
                else {
                    return false;
                }
            },
            removeLogoIco() {
                this.obj_Domain.RSI = true;
                this.$forceUpdate();
            },
            onFileIcoSelected(event) {
                this.selectedFileIco = this.validateFile(event, 5, [".ico"]);
                if (!this.bool_holSIBL) { // if choose local file
                    this.obj_Domain.RSI = true;
                }
            },
            onFileMLogoSelected(event) {
                this.selectedFileMsl = this.validateFile(event);
                if (!this.bool_holMSLBL) { // if choose local file
                    this.obj_Domain.RMSL = true;
                }

            },
            checkModuleAccess2(type) {
                if (type == this.constAccessType.add) {
                    if (this.checkModuleAccess('CRD', 'AGS', type)) {
                        return true;
                    }
                    else {
                        return this.checkModuleAccess('SUB', 'AGS', type);
                    }
                }
                else {
                    return this.checkModuleAccess('CRD', 'AGS', type);
                }
            },
            checkCreateDomainAccess() {
                var typeAdd = this.constAccessType.add;
                var typeEdit = this.constAccessType.edit;
                if (this.getUserInfo.AT < 4 && (this.checkModuleAccess('CRD', 'AGS', typeAdd) || this.checkModuleAccess('CRD', 'AGS', typeEdit))) {
                    return 2;
                }
                else if (this.checkModuleAccess('SUB', 'AGS', typeAdd) || this.checkModuleAccess('CRD', 'AGS', typeEdit)) {
                    return 1;
                }
                else {
                    return 0;
                }
            },
            // checkModuleAccessAltDomain(type) {
            //     return this.checkModuleAccess('CAD', 'AGS', type);
            // },
            addMyIP() {
                var MIP_C = window.baseIP;
                var exist = false;

                this.obj_MIP = {
                    MIP: MIP_C
                }

                MIP_C = MIP_C.replace(/\s/g, "").toLowerCase();
                MIP_C = this.findChar(MIP_C, MIP_C.length);

                for (var i = 0; i < this.obj_Domain.MaintenanceIP.length; i++) {
                    if (this.obj_Domain.MaintenanceIP[i].MIP == MIP_C) {
                        exist = true;
                        break;
                    }
                }
                if (exist) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["DM"]["WL"]), 1000);
                }
                else {
                    this.obj_Domain.MaintenanceIP.push(this.obj_MIP);
                }
            },
            addMaintenanceIP() {
                var exist = false;

                this.obj_Domain.MIP = this.obj_Domain.MIP.replace(/\s/g, "").toLowerCase();
                this.obj_Domain.MIP = this.findChar(this.obj_Domain.MIP, this.obj_Domain.MIP.length);

                if (this.obj_Domain.MIP.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"]["WL"]), 1000);
                }
                else if (!this.validateIP(this.obj_Domain.MIP)) {
                    this.showErrorMessage(null, this.getLanguage["ERR"]["IIPF"], 1000);
                }
                else {
                    var MIP_C = this.obj_Domain.MIP.trim();
                    this.obj_MIP = {
                        MIP: MIP_C
                    }
                    for (var i = 0; i < this.obj_Domain.MaintenanceIP.length; i++) {
                        if (this.obj_Domain.MaintenanceIP[i].MIP == MIP_C) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["DM"]["WL"]), 1000);
                    }
                    else {
                        this.obj_Domain.MaintenanceIP.push(this.obj_MIP);
                        this.obj_Domain.MIP = "";
                    }
                }
            },
            //Validate IP in IPv4 and IPv6 Format for Whitelist IP in addMaintenanceIP()
            validateIP(ip) {
                return this.validateIPv4(ip) || this.validateIPv6(ip);
            },
            validateIPv4(ip) {
                const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                return ipv4Pattern.test(ip);
            },
            validateIPv6(ip) {
                const ipv6Pattern = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|(?:[a-fA-F0-9]{1,4}:){1,6}:[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,5}(?::[a-fA-F0-9]{1,4}){1,2}|(?:[a-fA-F0-9]{1,4}:){1,4}(?::[a-fA-F0-9]{1,4}){1,3}|(?:[a-fA-F0-9]{1,4}:){1,3}(?::[a-fA-F0-9]{1,4}){1,4}|(?:[a-fA-F0-9]{1,4}:){1,2}(?::[a-fA-F0-9]{1,4}){1,5}|[a-fA-F0-9]{1,4}:(?::[a-fA-F0-9]{1,4}){1,6}|:(?::[a-fA-F0-9]{1,4}){1,7}|::$/i;
                return ipv6Pattern.test(ip);
            },
            removeMaintenanceIP(index) {
                this.$delete(this.obj_Domain.MaintenanceIP, index);
                this.$forceUpdate();
            },
            addADomainNameServer() {
                var exist = false;
                if (this.obj_ALDM.DNS.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"]["DNS"]), 1000);
                }
                else {
                    var DNS_C = this.obj_ALDM.DNS.trim();
                    this.obj_DNS = {
                        DNS: DNS_C,
                    }
                    for (var i = 0; i < this.obj_ALDM.DomainNameServer.length; i++) {
                        if (this.obj_ALDM.DomainNameServer[i].DNS == DNS_C) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["DM"]["DNS"]), 1000);
                    }
                    else {
                        this.obj_ALDM.DomainNameServer.push(this.obj_DNS);
                        this.obj_ALDM.DNS = "";
                    }
                }
            },
            removeALDDomainNameServer(index) {
                this.$delete(this.obj_ALDM.DomainNameServer, index);
                this.$forceUpdate();
            },
            addPDomainNameServer() {
                var exist = false;
                this.obj_Domain.DNS = this.obj_Domain.DNS.replace(/\s/g, "").toLowerCase();
                this.obj_Domain.DNS = this.findChar(this.obj_Domain.DNS, this.obj_Domain.DNS.length);

                if (this.obj_Domain.DNS.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"]["DNS"]), 1000);
                }
                else {
                    var DNS_C = this.obj_Domain.DNS.trim();
                    this.obj_DNS = {
                        DNS: DNS_C,
                    }
                    for (var i = 0; i < this.obj_Domain.DomainNameServer.length; i++) {
                        if (this.obj_Domain.DomainNameServer[i].DNS == DNS_C) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["DM"]["DNS"]), 1000);
                    }
                    else {
                        this.obj_Domain.DomainNameServer.push(this.obj_DNS);
                        this.obj_Domain.DNS = "";
                    }
                }
            },
            addAlternateDomainNameServer() {
                var exist = false;
                this.obj_ADomain.DNS = this.obj_ADomain.DNS.replace(/\s/g, "").toLowerCase();
                this.obj_ADomain.DNS = this.findChar(this.obj_ADomain.DNS, this.obj_ADomain.DNS.length);

                if (this.obj_ADomain.DNS.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"]["DNS"]), 1000);
                }
                else {
                    var DNS_C = this.obj_ADomain.DNS.trim();
                    this.obj_DNS = {
                        DNS: DNS_C,
                    }
                    for (var i = 0; i < this.obj_ADomain.DomainNameServer.length; i++) {
                        if (this.obj_ADomain.DomainNameServer[i].DNS == DNS_C) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["DM"]["DNS"]), 1000);
                    }
                    else {
                        this.obj_ADomain.DomainNameServer.push(this.obj_DNS);
                        this.obj_ADomain.DNS = "";
                    }
                }
            },
            checkUseCloudFlare(v) {
                this.obj_ADomain.UCF = v.target.checked;
                this.$forceUpdate();
            },
            removePDomainNameServer(index) {
                this.$delete(this.obj_Domain.DomainNameServer, index);
                this.$forceUpdate();
            },
            removeADomainNameServer(index) {
                this.$delete(this.obj_ADomain.DomainNameServer, index);
                this.$forceUpdate();
            },
            ValidationDomainErrMsg(value, langKey = "", index = -1) {
                if (this.bool_domainCV) {
                    var primaryLangKey = 'DM';
                    if (langKey == "") {
                        langKey = value;
                    }

                    if (value == 'SAGI') {
                        primaryLangKey = 'AG'
                    }
                    if (index < 0) {
                        if (value == 'SAGI') {
                            if (this.sagiError) {
                                return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[primaryLangKey][langKey]);
                            }
                        }
                        else if (this.$v.obj_Domain[value] != null && this.$v.obj_Domain[value].required != undefined && !this.$v.obj_Domain[value].required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[primaryLangKey][langKey]);
                        }
                    }
                    else {
                        if (this.$v.obj_Domain.DS.$each[index][value] != null && this.$v.obj_Domain.DS.$each[index][value].required != undefined && !this.$v.obj_Domain.DS.$each[index][value].required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[primaryLangKey][langKey]);
                        }
                    }
                }
            },
            SubAgentGroupChange(value, skipLoadDefaultSubBrand) {
                var that = this;
                var topItem = "";
                var SubAgentDomain = this.bool_isAD;
                this.isSubAgent = this.getUserInfo.AT == 4;
                var agi = 0;

                if (this.obj_Domain.AGIT != "" && this.obj_Domain.AGIT != null) {
                    agi = that.obj_Domain.AGIT.split("-")[1];

                    if (value > 0) {
                        this.isSubAgent = true;

                        that.bool_fullLoading = true;
                        that.getDataApi(`/api/ag/g/${value}`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.isOutlet = d.D.IOL;
                                } else {
                                    that.isOutlet = false;
                                }
                            });

                        that.getDataApi(`/api/dd/dn/${agi}`,
                            function (d, s) {
                                if (s) {
                                    that.dd_domain = d.dropdownlist;
                                } else {
                                    that.dd_domain = [];
                                }
                            });

                    }
                }
                else if (this.obj_ADomain.AGIT != "" && this.obj_ADomain.AGIT != null && this.bool_isAD) {
                    agi = that.obj_ADomain.AGIT.split("-")[1];

                    if (this.searchSubBrand2) {
                        agi = this.searchSubBrand2;
                    }

                    that.getDataApi(`/api/dd/dn-sag/${agi}`,
                        function (d, s) {
                            if (s) {
                                that.dd_domainlist = d.dropdownlist;
                            } else {
                                that.dd_domainlist = [];
                            }
                        });
                }

                if (!skipLoadDefaultSubBrand) {
                    that.loadDefaultSubBrand(value);
                }
            },
            AgentGroupChange(value, skipLoadDefaultSubBrand) {
                var that = this;
                this.bool_gameloaded = false;
                this.bool_currencyloaded = false;
                this.bool_languageloaded = false;
                this.bool_cacheOptionValue = false;
                var agi = 0, brandType = 0;

                if (value) {
                    agi = value.split("-")[1];
                    brandType = value.split("-")[0];

                    if (brandType == 4) {
                        this.searchSubBrand = agi;
                    }

                    this.SubAgentGroupChange(agi, false);
                }
                else {
                    this.searchSubBrand = null;
                }

                if (!skipLoadDefaultSubBrand) {
                    this.loadDefaultSubBrand(agi);
                }
                //console.log(value, brandType, agi);
                if (brandType != '4') { //subagent
                    //    //TODO: call api to get parent agi
                    //    that.getDataApi(`/api/sag/g/`+agi,
                    //        function (d, s) {
                    //            if (s) {
                    //                that.getDataApi(`/api/dd/dn/`+d.D.AAGI,
                    //                    function (data, status) {
                    //                        if (status) {
                    //                            that.dd_domain = data.dropdownlist;
                    //                        }else{
                    //                            that.dd_domain = [];
                    //                        }
                    //                    });
                    //            }else{
                    //                that.dd_domain = [];
                    //            }
                    //        });
                    //    that.isSubAgent = true;

                    //}else{
                    that.isSubAgent = this.getUserInfo.AT == 4 || this.checkCreateDomainAccess() == 1;

                    this.getDataApi('/api/dd/game/provbycur/' + agi + '/1',
                        function (d, s) {
                            if (s) {
                                that.bool_gameloaded = true;

                                for (var j = 0; j < d.dropdownlist.length; j++) {
                                    if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                        for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                            if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                                d.dropdownlist[j].children[l].label = that.getLanguage['GP'][d.dropdownlist[j].children[l].label];
                                                 if (that.constHouseBrand.includes(d.dropdownlist[j].children[l].id)) {
                                                     d.dropdownlist[j].children[l].isDisabled = true;
                                                 }
                                        }
                                    }
                                }
                                that.dd_gameprovider = that.appendSelectAllOption(d.dropdownlist);

                                if (that.obj_Domain != null && that.obj_Domain.I == 0 && that.obj_Domain.DS != null && that.obj_Domain.DS.length > 0) {
                                    for (var k = 0; k < that.obj_Domain.DS.length; k++) {
                                        that.obj_Domain.DS[k].GameProviderIdS = that.constHouseBrand;
                                        that.obj_Domain.DS[k].GPI = that.obj_Domain.DS[k].GameProviderIdS.join(',');
                                    }
                                }
                            }
                        });

                    this.getDataApi('/api/dd/cur/' + agi,
                        function (d, s) {
                            if (s) {
                                that.bool_currencyloaded = true;

                                for (var j = 0; j < d.dropdownlist.length; j++) {
                                    d.dropdownlist[j].id = d.dropdownlist[j].label;
                                }

                                that.dd_currency = that.appendSelectAllOption(d.dropdownlist);

                                if (that.obj_Domain != null && that.obj_Domain.I == 0 && that.obj_Domain.DS != null && that.obj_Domain.DS.length > 0) {
                                    for (var k = 0; k < that.obj_Domain.DS.length; k++) {
                                        that.obj_Domain.DS[k].CurrencyCodes = [];
                                        that.obj_Domain.DS[k].CC = "";
                                    }
                                }
                            }
                        });

                    this.getDataApi('/api/dd/lang/' + agi,
                        function (d, s) {
                            if (s) {
                                that.bool_languageloaded = true;

                                if (d.dropdownlist.length > 0) {
                                    for (var k = 0; k < that.obj_Domain.DS.length; k++) {
                                        var isSupported = false;

                                        for (var l = 0; l < d.dropdownlist.length; l++) {
                                            if (that.obj_Domain.DS[k].L == d.dropdownlist[l].id) {
                                                isSupported = true;
                                                break;
                                            }
                                        }

                                        that.obj_Domain.DS[k].LE = isSupported;

                                        if (!isSupported) {
                                            if (that.obj_Domain.DS[k].TC) {
                                                that.obj_Domain.DS[k].TC = isSupported;
                                                that.obj_Domain.DS[k].TI = null;

                                                if (that.obj_Domain.DL == that.obj_Domain.DS[k].L) {
                                                    that.obj_Domain.DL = null;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        });
                }
                //that.sensBtn = ((that.isSENS == 1 && agi != that.curAGI) ? true : false);
            },
            SMSVerificationChange() {
                if (this.obj_Domain.SMSV == 1) {
                    this.obj_Domain.SMSVP = '';
                    this.obj_Domain.SMSVPages = null;
                }
            },
            EmailVerificationChange() {
                if (this.obj_Domain.EV == 1) {
                    this.obj_Domain.EVP = '';
                    this.obj_Domain.EVPages = null;
                }
            },
            TemplateChange(value, index) {
                let that = this;
                if (!this.dd_templateskins[value]) {
                    this.getDataApi(`/api/dd/ts/` + value,
                        function (d, s) {
                            if (s) {
                                d.dropdownlist.sort((a, b) => {
                                    let fa = a.label.toLowerCase(),
                                        fb = b.label.toLowerCase();;

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                });

                                that.dd_templateskins[value] = d.dropdownlist;
                                that.dd_templateskins[value].push({ id: '0', label: that.getTemplateDefaultSkinColor(that.dd_template, index, value) });
                                that.rtDomainSettingKey = that.rtDomainSettingKey == 0 ? 1 : 0;
                            }
                        });
                }
                if (index >= 0) {
                    that.obj_Domain.DS[index].TSI = 0;
                }
            },
            MobileTemplateChange(value, index) {
                let that = this;
                if (!this.dd_mtemplateskins[value]) {
                    this.getDataApi(`/api/dd/ts/` + value,
                        function (d, s) {
                            if (s) {
                                d.dropdownlist.sort((a, b) => {
                                    let fa = a.label.toLowerCase(),
                                        fb = b.label.toLowerCase();;

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                });

                                that.dd_mtemplateskins[value] = d.dropdownlist;
                                that.dd_mtemplateskins[value].push({ id: '0', label: that.getTemplateDefaultSkinColor(that.dd_mtemplate, index, value) });
                                that.rtDomainSettingKey = that.rtDomainSettingKey == 0 ? 1 : 0;
                            }
                        });
                }
                if (index >= 0) {
                    that.obj_Domain.DS[index].MTSI = 0;
                }
            },
            getTemplateDefaultSkinColor(templateDD, index, value) {
                var defaultSkinColor = '';
                try {
                    if (templateDD) {
                        if (typeof index != 'undefined' && index >= 0) {
                            defaultSkinColor = templateDD[index].label2;
                        }
                        else if (value) {
                            for (var i = 0; i < templateDD.length; i++) {
                                if (templateDD[i].id == value) {
                                    defaultSkinColor = templateDD[i].label2;
                                    break;
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    defaultSkinColor = '';
                }

                return defaultSkinColor ? defaultSkinColor + ' (default)' : 'default';
            },
            tickSettingCheckbox(event, setting) {
                if (!event.target.checked) {
                    setting.TI = null;
                    setting.CurrencyCodes = [];
                    setting.CC = null;
                    setting.GameProviderIdS = [];
                    setting.GPI = "";
                    setting.AFB1188SW = null;
                    setting.AFB1188SM = null;
                    setting.AFB1188OS = null;
                    setting.AFB1188OM = null;

                    if (setting.L == this.obj_Domain.DL)
                        this.obj_Domain.DL = null;
                }
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_domainCV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getDomainList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getDomainList();

                    return false;
                }

                return true;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getDomainList();
            },
            boldDefaultLanguage(defaultlanguage, currentLanguage) {
                if (defaultlanguage == currentLanguage) {
                    return "bold";
                }
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList(loadList) {
                var that = this;

                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_language = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                            //// list filter only push in child group, do not include own group
                            // if (cloneParentGroup != null && cloneParentGroup.length > 0) {
                            //     that.dd_agentgroup = [];
                            //     for (var i = 0; i < cloneParentGroup.length; i++) {
                            //         if (cloneParentGroup[i].children != null && cloneParentGroup[i].children.length > 0) {
                            //             for (var j = 0; j < cloneParentGroup[i].children.length; j++) {
                            //                 that.dd_agentgroup.push(cloneParentGroup[i].children[j]);
                            //             }
                            //         }
                            //         else if (cloneParentGroup.length == 1) {
                            //             that.dd_agentgroup.push(cloneParentGroup[i]);
                            //         }
                            //     }
                            // }

                            that.dd_agentgroup3 = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup3.length > 0) {
                                that.dd_agentgroup3.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup2 = d.dropdownlist;

                            if (that.dd_agentgroup2.length > 0) {
                                that.dd_agentgroup2.forEach(that.disableAgentGroupParent2);
                            }

                            if (loadList)
                                that.getDomainList();

                        }
                    });
                this.AgentGroupChangefs(null);
                that.dd_1188SW = constAFB1188SkinW;
                that.dd_1188SM = constAFB1188SkinM;
                that.dd_1188OS = constAFB1188OddsStyle;
                that.dd_1188OM = constAFB1188OddsMode;
                that.dd_1188API = constAFB1188SportbookLaunchAPI;
            },
            disableAgentGroupParent2(item, index) {
                var agi = item.id.split("-");

                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent2);
                }
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");

                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            getDetailDropdownList(bool_showForm) {
                var that = this;
                var load_count = 0;

                this.dd_seorobots = this.appendSelectAllOption(constSEORobots);
                this.dd_smsverification = constSMSVerification;
                this.dd_emailverification = constEmailVerification;
                this.dd_verificationpage = this.appendSelectAllOption(constVerificationPage);

                if (this.dd_template.length == 0) {
                    this.getDataApi(`/api/dd/tp/1`,
                        function (d, s) {
                            if (s) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderTemplateName(d.dropdownlist[i].label);
                                }

                                d.dropdownlist.sort((a, b) => {
                                    let fa = a.label.toLowerCase(),
                                        fb = b.label.toLowerCase();;

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                });

                                that.dd_template = d.dropdownlist;
                            }
                            load_count++;

                            if (load_count == 2) {
                                that.bool_fullLoading = false;
                                that.bool_isAMV = true;
                            }
                        });
                }
                else if (bool_showForm) {
                    load_count++;

                    if (load_count == 2) {
                        this.bool_fullLoading = false;
                        this.bool_isAMV = true;
                    }
                }

                if (this.dd_mtemplate.length == 0) {
                    this.getDataApi(`/api/dd/tp`,
                        function (d, s) {
                            if (s) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderTemplateName(d.dropdownlist[i].label);
                                }

                                d.dropdownlist.sort((a, b) => {
                                    let fa = a.label.toLowerCase(),
                                        fb = b.label.toLowerCase();;

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                });

                                that.dd_mtemplate = d.dropdownlist;
                            }
                            load_count++;

                            if (load_count == 2) {
                                that.bool_fullLoading = false;
                                that.bool_isAMV = true;
                            }
                        });
                }
                else if (bool_showForm) {
                    load_count++;

                    if (load_count == 2) {
                        this.bool_fullLoading = false;
                        this.bool_isAMV = true;
                    }
                }

                if (this.dd_theme.length == 0) {
                    this.getDataApi(`/api/dd/th`,
                        function (d, s) {
                            if (s) {
                                that.dd_theme = d.dropdownlist;
                            }
                            load_count++;

                            if (load_count == 2) {
                                that.bool_fullLoading = false;
                                that.bool_isAMV = true;
                            }
                        });
                }
                else if (bool_showForm) {
                    load_count++;

                    if (load_count == 2) {
                        this.bool_fullLoading = false;
                        this.bool_isAMV = true;
                    }
                }
            },
            getDomainList() {
                this.bool_fullLoading = true;
                var that = this;

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    var agi = (this.arr_FV["SAGAGI"] == null) ? (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) : "4-" + this.arr_FV["SAGAGI"];

                    path += ("f.L_csv=" + this.arr_FV["L"] + "&f.ATAGI=" + agi);

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }
                    if (this.arr_FV.DI) {
                        path += "&f.DI=" + this.arr_FV["DI"];
                    }
                }

                this.getDataApi(`/api/dm/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_Domain = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            addDomain() {
                this.selectedFile = null;
                this.selectedFileMsl = null;
                this.bool_domainCV = false;
                this.bool_fullLoading = true;
                this.isChangeDomainName = false;

                this.obj_Domain.I = 0;
                this.obj_Domain.RS = 2;
                this.obj_Domain.DN = "";
                this.obj_Domain.L = "";
                this.obj_Domain.DL = null;
                this.obj_Domain.R = "";
                this.obj_Domain.RT = ""
                this.obj_Domain.AGIT = null;
                this.obj_Domain.AGI = "";
                this.obj_Domain.SRT = null;
                this.obj_Domain.SEOR = "";
                this.obj_Domain.MIP = "";
                this.obj_Domain.DNS = "";
                this.obj_Domain.DS = 0;
                this.obj_Domain.TI = 1;
                this.obj_Domain.SL = "";
                this.obj_Domain.RSL = false;
                this.obj_Domain.SLBL = false;
                this.obj_Domain.SI = "";
                this.obj_Domain.RSI = false;
                this.obj_Domain.SIBL = false;
                this.obj_Domain.MaintenanceIP = [];
                this.obj_Domain.DomainNameServer = [];
                this.obj_Domain.DALT = [];
                this.obj_Domain.ADI = null;
                this.obj_Domain.CN = "";
                this.obj_Domain.SIP = "";
                this.obj_Domain.PDI = null;
                this.obj_Domain.SAESEO = false;
                this.obj_Domain.IOL = false;
                this.obj_Domain.IM = null;
                this.searchSubBrand = null;   //SubBrand AGI
                this.ddDefaultSubBrand = [];    //Defauld DD for Sub Brand
                this.isSubAgent = this.getUserInfo.AT == 4;
                this.isOutlet = false;
                this.obj_Domain.RTW = null;
                this.obj_ADomain.AFB1188SBAPI = null;
                var acc = this.checkCreateDomainAccess();
                this.obj_Domain.AMPSU = "amp";
                this.obj_Domain.MSL = "";
                this.obj_Domain.RMSL = false;
                this.obj_Domain.MSLBL = false;
                this.selectedFileMsl = null;

                if (acc == 1) {
                    this.isSubAgent = true;
                }

                this.dd_domain = [];
                var DS = [];
                if (this.dd_language.length > 0) {
                    for (var i = 0; i < this.dd_language.length; i++) {
                        DS[i] = {
                            "I": 0,
                            "TC": false,
                            "LE": true,
                            "L": this.dd_language[i].id,
                            "LN": this.dd_language[i].label,
                            "CC": null,
                            "CurrencyCodes": [],
                            "TI": null,
                            "GPI": "",
                            "GameProviderIdS": [],
                            "CURL": "",
                            "GCURL": "",
                            "AFB1188SW": null,
                            "AFB1188SM": null,
                            "AFB1188OS": null,
                            "AFB1188OM": null,
                        };
                    }
                }

                if (this.getUserInfo.AT == 4) {
                    this.obj_Domain.AGIT = "4-" + this.getUserInfo.AGI;
                }

                this.$set(this.$data.obj_Domain, 'DS', DS);
                this.getDetailDropdownList(true);

                if (this.getUserInfo.AT == 4) {
                    this.AgentGroupChange(this.obj_Domain.AGIT);
                }
            },
            OpenAlternateDomain(agi = 0, domainId = 0) {
                this.obj_ADomain.I = 0;
                this.obj_ADomain.RS = 2;
                this.obj_ADomain.DN = "";
                if (agi > 0) {
                    this.obj_ADomain.AGI = agi;
                    this.obj_ADomain.AGIT = "3-" + agi;
                    this.DomainAgentGroupChange(this.obj_ADomain.AGIT);
                }
                else {
                    this.obj_ADomain.AGI = "";
                    this.obj_ADomain.AGIT = null;
                }
                this.obj_ADomain.DNS = "";

                if (domainId > 0) {
                    this.obj_ADomain.DI = domainId;
                }
                else {
                    this.obj_ADomain.DI = null;
                }
                this.obj_ADomain.DomainNameServer = [];
                this.obj_ADomain.ADI = null;
                this.obj_ADomain.CN = "";
                this.obj_ADomain.UCF = true;
                this.obj_ADomain.RT = "";

                this.bool_isAD = true;
                this.dd_domainlist = [];
                this.bool_ADomainCV = false;
                this.searchSubBrand2 = null;   //SubBrand AGI
            },
            EditAlternateDomain(alternateDomainId) {
                this.bool_fullLoading = true;
                var that = this;

                this.getDataApi(`/api/dm/gad/${alternateDomainId}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_fullLoading = true;
                            that.obj_ADomain = Object.assign(that.obj_ADomain, d.D);
                            if (that.obj_ADomain.AGI != 0) {
                                that.obj_ADomain.AGIT = "3-" + that.obj_ADomain.AGI;
                                that.DomainAgentGroupChange(that.obj_ADomain.AGIT);
                            }

                            if (that.obj_ADomain.AGI != 0 && that.obj_ADomain.SAGAGI > 0) {
                                that.SubAgentGroupChange(that.searchSubBrand2);
                                that.searchSubBrand2 = that.obj_ADomain.SAGAGI;
                            }

                            that.obj_ADomain.DomainNameServer = [];
                            if (that.obj_ADomain.DNS != "" && that.obj_ADomain.DNS != null) {
                                var DNS_C = that.obj_ADomain.DNS;
                                that.obj_ADomain.DNS = "";
                                var DNS_CARRY = DNS_C.split(',');
                                for (var i = 0; i < DNS_CARRY.length; i++) {
                                    that.obj_DNS = {
                                        DNS: DNS_CARRY[i]
                                    }
                                    that.obj_ADomain.DomainNameServer.push(that.obj_DNS);
                                }
                            }

                            that.bool_isAD = true;
                        }
                        that.bool_fullLoading = false;
                    });
            },
            removeDomain(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/dm/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getDomainList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            editDomain(id) {
                if (this.getUserInfo.AT == 3) {
                    this.isAgent = true;
                }

                this.searchSubBrand = null;
                this.selectedFile = null;
                this.selectedFileMsl = null;
                this.bool_domainCV = false;
                this.bool_fullLoading = true;
                this.isChangeDomainName = false;
                var that = this;
                this.getDetailDropdownList(false);

                this.getDataApi(`/api/dm/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_Domain = Object.assign(that.obj_Domain, d.D);
                            var DS = [];
                            if (that.dd_language.length > 0) {
                                for (var i = 0; i < that.dd_language.length; i++) {
                                    DS[i] = {
                                        "I": 0,
                                        "TC": false,
                                        "LE": false,
                                        "L": that.dd_language[i].id,
                                        "LN": that.dd_language[i].label,
                                        "CC": null,
                                        "CurrencyCodes": [],
                                        "TI": null,
                                        "MTI": null,
                                        "GPI": "",
                                        "GameProviderIdS": [],
                                        "CURL": "",
                                        "GCURL": "",
                                        "AFB1188SW": null,
                                        "AFB1188SM": null,
                                        "AFB1188OS": null,
                                        "AFB1188OM": null,
                                    };

                                    if (d.D.DS) {
                                        d.D.DS.find(function (val, idx) {
                                            if (val.L == that.dd_language[i].id) {
                                                DS[i].I = val.I;
                                                DS[i].TC = true;
                                                DS[i].LE = true;
                                                DS[i].CC = val.CC;
                                                DS[i].CurrencyCodes = val.CurrencyCodes;
                                                DS[i].TI = val.TI;
                                                DS[i].TSI = val.TSI;
                                                DS[i].MTI = val.MTI;
                                                DS[i].MTSI = val.MTSI;
                                                DS[i].GPI = val.GPI;
                                                DS[i].GameProviderIdS = val.GameProviderIdS;
                                                DS[i].CURL = val.CURL;
                                                DS[i].GCURL = val.GCURL;
                                                if (val.AFB1188SW != "")
                                                    DS[i].AFB1188SW = val.AFB1188SW;
                                                if (val.AFB1188SM != "")
                                                    DS[i].AFB1188SM = val.AFB1188SM;
                                                if (val.AFB1188OS != "")
                                                    DS[i].AFB1188OS = val.AFB1188OS;
                                                if (val.AFB1188OM != "")
                                                    DS[i].AFB1188OM = val.AFB1188OM;
                                                if (DS[i].TI > 0) that.TemplateChange(DS[i].TI);
                                                if (DS[i].MTI > 0) {
                                                    that.MobileTemplateChange(DS[i].MTI);
                                                }
                                                else {
                                                    DS[i].MTI = null;
                                                }
                                            }
                                        });
                                    }
                                }
                            }

                            if (that.obj_Domain.SMSVP != null && that.obj_Domain.SMSVP.length > 0) {
                                that.obj_Domain.SMSVPages = that.obj_Domain.SMSVP.split(',');
                            }
                            else {
                                that.obj_Domain.SMSVPages = null;
                            }

                            if (that.obj_Domain.EVP != null && that.obj_Domain.EVP.length > 0) {
                                that.obj_Domain.EVPages = that.obj_Domain.EVP.split(',');
                            }
                            else {
                                that.obj_Domain.EVPages = null;
                            }

                            that.$set(that.$data.obj_Domain, 'DS', DS);

                            if (that.obj_Domain.AGI != 0) {
                                that.obj_Domain.AGIT = "3-" + that.obj_Domain.AGI;
                                that.AgentGroupChange(that.obj_Domain.AGIT, true);
                            }

                            if (that.obj_Domain.AGI != 0 && that.obj_Domain.PDI > 0) {
                                that.searchSubBrand = that.obj_Domain.SAGAGI;
                                that.SubAgentGroupChange(that.searchSubBrand);

                                that.isSubAgent = true;
                            }

                            that.bool_holSLBL = that.obj_Domain.SLBL;
                            if (that.bool_holSLBL) {
                                that.obj_Domain.LOGOByLink = that.obj_Domain.SL
                            }
                            that.bool_holSIBL = that.obj_Domain.SIBL;
                            if (that.bool_holSIBL) {
                                that.obj_Domain.ICONByLink = that.obj_Domain.SI
                            }
                            that.bool_holMSLBL = that.obj_Domain.MSLBL;
                            if (that.bool_holMSLBL) {
                                that.obj_Domain.MobileLOGOByLink = that.obj_Domain.MSL
                            }

                            that.obj_Domain.MaintenanceIP = [];
                            if (that.obj_Domain.MIP != "" && that.obj_Domain.MIP != null) {
                                var MIP_C = that.obj_Domain.MIP;
                                that.obj_Domain.MIP = "";
                                var MIP_CARRY = MIP_C.split(',');
                                for (var i = 0; i < MIP_CARRY.length; i++) {
                                    that.obj_MIP = {
                                        MIP: MIP_CARRY[i]
                                    }
                                    that.obj_Domain.MaintenanceIP.push(that.obj_MIP);
                                }
                            }

                            that.obj_Domain.DomainNameServer = [];
                            if (that.obj_Domain.DNS != "" && that.obj_Domain.DNS != null) {
                                var DNS_C = that.obj_Domain.DNS;
                                that.obj_Domain.DNS = "";
                                var DNS_CARRY = DNS_C.split(',');
                                for (var i = 0; i < DNS_CARRY.length; i++) {
                                    that.obj_DNS = {
                                        DNS: DNS_CARRY[i]
                                    }
                                    that.obj_Domain.DomainNameServer.push(that.obj_DNS);
                                }
                            }

                            that.OldDomainName = that.obj_Domain.DN;

                            that.dd_dofs = [];
                            if (that.obj_Domain.I > 0 && that.obj_Domain.AGI > 0) {
                                that.refreshDofs(that, that.obj_Domain.AGI);
                            }

                            if (that.obj_Domain.RT == null || that.obj_Domain.RT == '') {
                                that.obj_Domain.RT = "";
                            }

                            if (that.obj_Domain.IM == 0) {
                                that.obj_Domain.IM = null;
                            }

                            if (that.obj_Domain.AFB1188SBAPI == '') {
                                that.obj_Domain.AFB1188SBAPI = null;
                            }

                            that.bool_isAMV = true;
                        }
                    });

            },
            clearCache(d) {
                this.bool_fullLoading = true;
                var that = this;
                var dt = {
                    i: d.I,
                    agi: d.AGI
                };

                this.postDataApi(`/api/dm/cc`, dt,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },
            refreshDofs(that, id) {
                that.getDataApi(`/api/dd/dn/` + id,
                    function (d, s) {
                        if (s) {
                            let dropdown = d.dropdownlist.map(x => { return { "id": x.label, "label": x.label } });
                            if (that.obj_Domain.DALT && that.obj_Domain.DALT.length > 0) {
                                that.obj_Domain.DALT.forEach((x, i, arr) => {
                                    dropdown.push({ "id": x.DN, "label": x.DN });
                                });
                            }
                            that.dd_dofs = dropdown;
                        }
                    });
            },
            getIURLTabIndex(id) {
                var result = 0;
                try {
                    var x = document.querySelector(id + ' .nav.nav-tabs li a.active');
                    if (x && x.innerText == "Upload Image") {
                        result = 1;
                        return result;
                    }
                    else {
                        result = 2;
                        return result;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
                return result;
            },
            saveDomain() {
                this.bool_fullLoading = true;
                var that = this;
                this.sagiError = false;

                //// check the require field
                //site logo
                var iurlTab = this.getIURLTabIndex("#imageURLTab");
                if (iurlTab == 2) { // external img url - obj_Domain['SL']
                    if (this.obj_Domain.LOGOByLink != null && this.obj_Domain.LOGOByLink != "") {
                        this.obj_Domain.SLBL = true;
                    }
                } else {
                    this.obj_Domain.SLBL = false;
                }
                //site ico
                var SiurlTab = this.getIURLTabIndex("#imageURLTab2");
                if (SiurlTab == 2) { // external img url
                    if (this.obj_Domain.ICONByLink != null && this.obj_Domain.ICONByLink != "") {
                        this.obj_Domain.SIBL = true;
                    }
                } {
                    this.obj_Domain.SIBL = false;
                }
                //mobile site logo
                var MslurlTab = this.getIURLTabIndex("#imageURLTab3");
                if (MslurlTab == 2) { // external img url
                    if (this.obj_Domain.MobileLOGOByLink != null && this.obj_Domain.MobileLOGOByLink != "") {
                        this.obj_Domain.MSLBL = true;
                    }
                } else {
                    this.obj_Domain.MSLBL = false;
                }
                var selectedLanguage = [];

                for (var i = 0; i < this.obj_Domain.DS.length; i++) {
                    if (this.obj_Domain.DS[i].TC) {
                        selectedLanguage.push(this.obj_Domain.DS[i].L);

                        if (this.obj_Domain.DS[i].CurrencyCodes != null && this.obj_Domain.DS[i].CurrencyCodes.length > 0) {
                            this.obj_Domain.DS[i].CC = this.obj_Domain.DS[i].CurrencyCodes.join(',');
                        }

                        if (this.obj_Domain.DS[i].GameProviderIdS != null && this.obj_Domain.DS[i].GameProviderIdS.length > 0) {
                            this.obj_Domain.DS[i].GPI = this.obj_Domain.DS[i].GameProviderIdS.join(',');
                        }
                    }
                }

                if (selectedLanguage.length > 0)
                    this.obj_Domain['L'] = selectedLanguage.join(',');
                else {
                    this.obj_Domain['L'] = "";
                }

                if (this.searchSubBrand != null) {
                    this.obj_Domain.AGI = this.searchSubBrand;
                } else {
                    if (this.obj_Domain.AGIT != null && this.obj_Domain.AGIT.length > 0) {
                        var agi = this.obj_Domain.AGIT.split("-");
                        this.obj_Domain.AGI = agi[1];
                    }
                }

                if (this.obj_Domain.MaintenanceIP != null && this.obj_Domain.MaintenanceIP.length > 0) {
                    this.obj_Domain.MIP = "";
                    for (var i = 0; i < this.obj_Domain.MaintenanceIP.length; i++) {
                        if (i != 0) {
                            this.obj_Domain.MIP += ",";
                        }
                        this.obj_Domain.MIP += this.obj_Domain.MaintenanceIP[i].MIP;
                    }
                }

                if (this.obj_Domain.DomainNameServer != null && this.obj_Domain.DomainNameServer.length > 0) {
                    this.obj_Domain.DNS = "";
                    for (var i = 0; i < this.obj_Domain.DomainNameServer.length; i++) {
                        if (i != 0) {
                            this.obj_Domain.DNS += ",";
                        }
                        this.obj_Domain.DNS += this.obj_Domain.DomainNameServer[i].DNS;
                    }
                }

                if (this.obj_Domain.SRT != null && this.obj_Domain.SRT.length > 0) {
                    this.obj_Domain['SEOR'] = this.obj_Domain.SRT.join(',');
                }
                else {
                    this.obj_Domain['SEOR'] = "";
                }

                if (this.obj_Domain.SMSVPages != null && this.obj_Domain.SMSVPages.length > 0) {
                    this.obj_Domain.SMSVP = this.obj_Domain.SMSVPages.join(',');
                }

                if (this.obj_Domain.EVPages != null && this.obj_Domain.EVPages.length > 0) {
                    this.obj_Domain.EVP = this.obj_Domain.EVPages.join(',');
                }
                if (this.obj_Domain.SLBL != this.bool_holSLBL && this.obj_Domain.SLBL) {
                    this.obj_Domain.RSL = true
                }
                if (this.obj_Domain.SIBL != this.bool_holSIBL && this.obj_Domain.SLBI) {
                    this.obj_Domain.RSI = true
                }
                if (this.obj_Domain.MSLBL != this.bool_holMSLBL && this.obj_Domain.MSLBL) {
                    this.obj_Domain.RMSL = true
                }
                this.obj_Domain["NSL"] = this.selectedFile;
                this.obj_Domain["NSI"] = this.selectedFileIco;
                this.obj_Domain["NMSL"] = this.selectedFileMsl;
                this.bool_domainCV = true;
                this.$v.obj_Domain.$touch();
                var validationError = false;

                if (this.checkCreateDomainAccess() == 1 && !this.searchSubBrand) {
                    this.sagiError = true;
                    validationError = true;
                }

                if (!validationError && !this.$v.obj_Domain.$error) {
                    if (this.isChangeDomainName) {
                        this.bool_fullLoading = false;
                        var title = this.getLanguage["DM"]["COM"] + " " + this.OldDomainName + " > " + this.obj_Domain.DN + "?";
                        this.$fire({
                            title: title,
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["CONFIRM"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                this.bool_fullLoading = true;
                                this.bool_fullScreen = true;
                                this.postDataApiWithAttach(`/api/dm/s`, this.obj_Domain,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        that.bool_fullScreen = false;
                                        if (s) {
                                            that.bool_isAMV = false;
                                            that.selectedFile = null;
                                            that.selectedFileIco = null;
                                            that.selectedFileMsl = null;
                                            that.getDomainList();
                                        }
                                    });
                            }
                        });
                    } else {
                        this.bool_fullLoading = true;
                        this.bool_fullScreen = true;
                        this.postDataApiWithAttach(`/api/dm/s`, this.obj_Domain,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.selectedFile = null;
                                    that.selectedFileIco = null;
                                    that.selectedFileMsl = null;
                                    that.getDomainList();
                                }
                            });
                    }

                }
                else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["obj_Domain"];
                    if (!validation) {
                        return;
                    }

                    //get the ref which has a smaller uid opposite others and is unfilled.
                    function predicateRef(refIndex, getProp) {
                        //handle the array format in the validation
                        if (refIndex.name.includes("$each")) {
                            const nameParts = refIndex.name.split(".");
                            for (let i = 0; i < refIndex.component.length; i++) {
                                const namePath = `${nameParts[0]}.$each.${i}.${nameParts[2]}`;
                                const validationProp = getProp(validation, namePath);
                                if (!validationProp || !validationProp.$error) {
                                    continue;
                                }

                                return refIndex.component[i];
                            }
                        } else {
                            const validationProp = getProp(validation, refIndex.name);
                            if (!validationProp || !validationProp.$error) {
                                return;
                            }

                            //handle the Language inputs
                            if (Array.isArray(refIndex.component)) {
                                return refIndex.component.find(r => r.disabled === false && r.checked === false);
                            } else {
                                return refIndex.component;
                            }
                        }
                    }

                    const input = this.findRequiredInput(validation, this.$refs, predicateRef);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_Domain.R = event.target.value;
                }
                else if (type == "RTD") {
                    this.obj_Domain.RT = event.target.value;
                }
                else if (type == "RTAD") {
                    this.obj_ALDM.RT = event.target.value;
                }
                else if (type == "CNTA") {
                    this.obj_ALDM.CN = event.target.value;
                }
                else if (type == "CNT") {
                    this.obj_Domain.CN = event.target.value;
                }
                else if (type == "ART") {
                    this.obj_ADomain.RT = event.target.value;
                }
                else if (type == "CNNC") {
                    this.obj_ADomain.CN = event.target.value;
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: "",
                    endDate: ""
                };
            },
            renderTemplateName(TemplateName) {
                if (TemplateName && TemplateName in this.getLanguage['TMPE'])
                    return this.getLanguage['TMPE'][TemplateName];
                else
                    return TemplateName;
            },
            getDefaultRobotsTxt(isPrimary) {
                if (isPrimary == 1) {
                    return "User-agent: *\nDisallow: /\n\nSitemap: https://" + (this.obj_Domain && this.obj_Domain.DN != null && this.obj_Domain.DN != "" ? this.obj_Domain.DN : '{domain name}') + "/sitemap.xml";
                }
                else {
                    return "User-agent: *\nDisallow: /\n\nSitemap: https://" + ((this.obj_ALDM && this.obj_ALDM.I > 0 && this.obj_ALDM.DN != null && this.obj_ALDM.DN != "") ? this.obj_ALDM.DN : '{domain name}') + "/sitemap.xml";
                }
            },
            resetField(type) {
                if (type == "RT") {
                    this.obj_Domain.RT = "";
                    this.rtKey = this.rtKey == 0 ? 1 : 0;
                }
                else if (type == "CRT") {
                    this.obj_ALDM.RT = "";
                    this.rtAltKey = this.rtAltKey == 0 ? 1 : 0;
                }
                else if (type == "ART") {
                    this.obj_ADomain.RT = "";
                    this.rtAltDKey = this.rtAltDKey == 0 ? 1 : 0;
                }
            },
            removeAlternateDomain(index) {
                this.$delete(this.obj_Domain.DALT, index);
                this.altdmKey = this.altdmKey == 0 ? 1 : 0;
            },
            editAlternateDomain(index) {
                this.obj_ALDM = this.obj_Domain.DALT[index];
                this.obj_ALDM.index = index;
                this.obj_ALDM.DomainNameServer = [];
                if (this.obj_ALDM.DNS != "") {
                    var DNS_C = this.obj_ALDM.DNS;
                    var DNS_CARRY = DNS_C.split(',');
                    for (var i = 0; i < DNS_CARRY.length; i++) {
                        this.obj_DNS = {
                            DNS: DNS_CARRY[i]
                        }
                        this.obj_ALDM.DomainNameServer.push(this.obj_DNS);
                    }
                }
                if (this.obj_ALDM.RT == null || this.obj_ALDM.RT == '') {
                    this.obj_ALDM.RT = this.getDefaultRobotsTxt(0);
                }
                this.bool_altDomainCV = false;
                this.bool_isEditALtDM = true;
            },
            addAlternateDomain() {
                this.obj_ALDM = {
                    I: 0,
                    DN: null,
                    DomainNameServer: [],
                    RT: null,
                    index: -1,
                    CN: ""
                };

                this.bool_altDomainCV = false;
                this.bool_isEditALtDM = true;
            },

            findChar(str, index) {
                var allow = new RegExp(/[0-9a-z]/, 'gi');
                if (!str.charAt(str.length - 1).match(allow)) {
                    str = str.slice(0, -1);
                    return this.findChar(str, index - 1);
                }
                return str;
            },
            saveAlternateDomain() {
                this.bool_altDomainCV = true;
                this.$v.obj_ALDM.$touch();

                if (!this.$v.obj_ALDM.$error) {
                    this.bool_isEditALtDM = false;
                    this.obj_ALDM.DNS = "";
                    if (this.obj_ALDM.DomainNameServer != null && this.obj_ALDM.DomainNameServer.length > 0) {
                        for (var i = 0; i < this.obj_ALDM.DomainNameServer.length; i++) {
                            if (i != 0) {
                                this.obj_ALDM.DNS += ",";
                            }
                            this.obj_ALDM.DNS += this.obj_ALDM.DomainNameServer[i].DNS;
                        }
                    }
                    this.obj_ALDM.DN = this.obj_ALDM.DN.replace(/\s/g, "").toLowerCase();
                    this.obj_ALDM.DN = this.findChar(this.obj_ALDM.DN, this.obj_ALDM.DN.length);


                    if (this.obj_ALDM.index == -1) {
                        this.obj_Domain.DALT.push(this.obj_ALDM);
                    }
                    else {
                        this.obj_Domain.DALT[this.obj_ALDM.index] = this.obj_ALDM;
                    }
                    this.altdmKey = this.altdmKey == 0 ? 1 : 0;
                    if (this.obj_Domain.I > 0 && this.obj_Domain.AGI > 0) {
                        this.refreshDofs(this, this.obj_Domain.AGI);
                    }
                } 
            },
            cancelAlternateDomain() {
                this.bool_isEditALtDM = false;
            },
            ValidationAlternateDomainErrMsg(value) {
                if (this.bool_altDomainCV) {
                    if (!this.$v.obj_ALDM[value].required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage['DM']['DN']);
                    }
                }
            },
            closeAlternateDomain() {
                this.bool_isAD = false;
            },
            DomainAgentGroupChange(value) {
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_domainlist = d.dropdownlist;
                            }
                        });
                }
                else {
                    that.dd_domainlist = [];
                }
                this.obj_ADomain.AGI = agi;
                //this.sensBtn = ((this.isSENS == 1 && agi != this.curAGI) ? true : false);
            },
            ValidationNewAlternateDomainErrMsg(value, langKey = "") {
                if (this.bool_ADomainCV) {
                    if (langKey == "") {
                        langKey = value;
                    }
                    if (this.$v.obj_ADomain[value].required != undefined && !this.$v.obj_ADomain[value].required) {
                        this.bool_fullLoading = false;
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"][langKey]);
                    }
                }
            },
            saveNAlternateDomain() {
                var that = this;
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                this.bool_ADomainCV = true;
                this.$v.obj_ADomain.$touch();

                if (!this.$v.obj_ADomain.$error) {
                    this.bool_ADomainCV = false;
                    this.obj_ADomain.DNS = "";
                    if (this.obj_ADomain.DomainNameServer != null && this.obj_ADomain.DomainNameServer.length > 0) {
                        for (var i = 0; i < this.obj_ADomain.DomainNameServer.length; i++) {
                            if (i != 0) {
                                this.obj_ADomain.DNS += ",";
                            }
                            this.obj_ADomain.DNS += this.obj_ADomain.DomainNameServer[i].DNS;
                        }
                    }
                    this.obj_ADomain.DN = this.obj_ADomain.DN.replace(/\s/g, "").toLowerCase();
                    this.obj_ADomain.DN = this.findChar(this.obj_ADomain.DN, this.obj_ADomain.DN.length);

                    if (this.searchSubBrand2 != null) {
                        this.obj_ADomain.AGI = this.searchSubBrand2;
                    } else {
                        if (this.obj_ADomain.AGIT != null && this.obj_ADomain.AGIT.length > 0) {
                            var agi = this.obj_ADomain.AGIT.split("-");
                            this.obj_ADomain.AGI = agi[1];
                        }
                    }

                    this.postDataApi(`/api/dm/ad/`, this.obj_ADomain,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAD = false;
                                that.newSearch();
                            }
                        });
                }
                else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["obj_ADomain"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            deleteAlternateDomain() {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: this.obj_ADomain.I,
                            uts: this.obj_ADomain.UTS,
                            agi: this.obj_ADomain.AGI
                        };

                        this.postDataApi(`/api/dm/dad`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.bool_isAD = false;
                                    that.getDomainList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            displayDNSLine(dnsCSV) {
                return dnsCSV.replace(/,/g, ", ");
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_Domain.AGIT != null && this.obj_Domain.AGIT.length > 0) {
                    var agi = this.obj_Domain.AGIT.split("-");
                    parentAGI = agi[1];
                } else if (this.obj_ADomain.AGIT != null && this.obj_ADomain.AGIT.length > 0) {
                    var agi = this.obj_ADomain.AGIT.split("-");
                    parentAGI = agi[1];
                } else if (this.arr_FV.AGI != null && this.arr_FV.AGI.length > 0) {
                    var agi = this.arr_FV.AGI.split("-");
                    parentAGI = agi[1];
                }
                else {
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubBrandList = d.dropdownlist;
                                that.ddSubBrandList2 = d.dropdownlist;
                                that.ddSubBrandList3 = d.dropdownlist;
                                that.bool_cacheOptionValue = true;
                            }

                            callback(null, that.ddSubBrandList);
                        });
                }
            },
            loadDefaultSubBrand(SAGAGI = 0) {
                var that = this;
                var searchQuery = "0";
                var parentAGI = 0;

                if (SAGAGI == 0) {
                    if (this.obj_Domain.AGI > 0) {
                        parentAGI = this.obj_Domain.AGI;
                    } else if (this.obj_ADomain.AGI > 0) {
                        parentAGI = this.obj_ADomain.AGI;
                    }
                } else {
                    parentAGI = SAGAGI;
                }

                if (parentAGI) {
                    that.bool_fullLoading = true;
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/1`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s && d && d.dropdownlist) {
                                that.ddDefaultSubBrand = d.dropdownlist;
                                that.ddSubBrandList3 = d.dropdownlist;
                                that.rtSubBrandKey = that.rtSubBrandKey == 0 ? 1 : 0;
                            }
                        });
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            AgentGroupChangefs(value) {
                this.arr_FV.SAGAGI = null;
                this.arr_FV.DI = null;
                if (value) {
                    var split = value.split("-");
                    if (split.length == 2) {
                        this.filter_agi = split[1];
                    }
                    else {
                        this.filter_agi = split[0];
                    }
                } else {
                    this.filter_agi = '-1';  // -1 mean select all
                }
                var that = this;
                this.getDataApi(`/api/dd/dn/` + this.filter_agi.toString(),
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_dn = d.dropdownlist;
                        }
                    });
            },
            SubAgentGroupChangefs(value) {
                var that = this;
                this.arr_FV.DI = null;
                if (value) {
                    this.getDataApi(`/api/dd/dn-sag/` + value.toString(),
                        function (d, s) {
                            if (s) {
                                that.dd_dn = d.dropdownlist;
                            }
                        });
                } else {
                    this.getDataApi(`/api/dd/dn/` + this.filter_agi.toString(),
                        function (d, s) {
                            if (s) {
                                that.dd_dn = d.dropdownlist;
                            }
                        });
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        created() {
            this.reportHeaders = null;
            if (this.$route.path == '/AGS/CRD') {
                this.$parent.showSubMenu = 'AGS';
                this.$parent.showActiveMenu = 'AGS.CRD';
            } else if (this.$route.path == '/WEBS/CRD') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showActiveMenu = 'WEBS.CRD';
            }

            var parameters = this.$route.query;
            this.ModuleAccessAltDomain_add = this.checkModuleAccess('CAD', 'AGS', constAccessType.add);
            this.ModuleAccessAltDomain_edit = this.checkModuleAccess('CAD', 'AGS', constAccessType.edit);
            this.ModuleAccessAltDomain_delete = this.checkModuleAccess('CAD', 'AGS', constAccessType.delete);

            this.isSubAgent = this.getUserInfo.AT == 4 || this.checkCreateDomainAccess() == 1;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

            if (parameters.agi !== undefined) {
                this.getDropdownList(true);
                this.arr_FV.AGI = parameters.agi;
                this.AgentGroupChangefs(parameters.agi);
                if (parameters.sagi !== undefined) {
                    this.arr_FV.SAGAGI = parameters.sagi;
                    this.loadDefaultSubBrand(this.arr_FV.SAGAGI);
                }
            }
            else {
                this.getDropdownList(false);
                this.getDomainList();
            }
        }
    }
</script>
<style>
    .tab-content .tab-pane {
        padding: 5px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/CreateDomain.vue